var validatePropType = function (prop, type) {
    if (prop && type) {
        var PropAvailability = Object.keys(type)
            .map(function (key) { return type[key]; })
            .indexOf(prop) > -1;
        if (!PropAvailability) {
            console.error(PropAvailability, "Expected values: ".concat(Object.keys(type).join(', ')));
        }
        return PropAvailability;
    }
};

export { validatePropType };
